import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	data: null,
	error: '',
	hasBeenLoaded: false,
	isLoading: false
};

export const newsletterSlice = createSlice({
	name: 'newsletter',
	initialState,
	reducers: {
		signUpForNewsletter: (state) => {
			state.isLoading = true;
		},
		signUpForNewsletterCompleted: (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.hasBeenLoaded = true;
			state.error = '';
		},
		signUpForNewsletterFailed: (state, action) => {
			state.isLoading = false;
			state.hasBeenLoaded = false;
			state.error = action.payload;
		}
	}
});

export const {
	signUpForNewsletter,
	signUpForNewsletterCompleted,
	signUpForNewsletterFailed
} = newsletterSlice.actions;

export default newsletterSlice.reducer;
